export default {
    categorias: [],
    buscouTodasAsCategorias: false,
    ordenacaoDeAZ: true
}